import { useAtomValue } from "jotai";
import { FormEvent } from "react";

import { paymentQuestionAtom } from "atoms/PayeeQuestions/questions";
import { Locale } from "types/locale";

import { PaymentQuestions } from "../types";
import { isAcceptanceValidAtom } from "atoms/PayeeQuestions/formValidation";

export const useAcceptanceForm = (locale: Locale) => {
  const paymentQuestion = useAtomValue(paymentQuestionAtom);
  const isValid = useAtomValue(isAcceptanceValidAtom);
  const handleSubmit = (onSubmit: (data: PaymentQuestions) => void) => (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(paymentQuestion);
  };


  return {
    handleSubmit,
    isValid,
  };
};
